import React, { FC } from 'react';

const TransactionRefund: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="500"
      height="500"
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M335.501 408.8H164.901C124.101 408.8 90.8008 375.6 90.8008 334.7V164.2C90.8008 123.4 124.001 90.1001 164.901 90.1001H335.501C376.301 90.1001 409.601 123.3 409.601 164.2V334.8C409.601 375.6 376.401 408.8 335.501 408.8Z"
        fill="#EFF2F4"
      />
      <path
        d="M360.299 164.6H139.499C133.799 164.6 129.199 160 129.199 154.3C129.199 148.6 133.799 144 139.499 144H360.299C365.999 144 370.599 148.6 370.599 154.3C370.599 160 365.999 164.6 360.299 164.6Z"
        fill="#231F20"
      />
      <path d="M342.2 144H156.6V333.5H342.2V144Z" fill="#FF2B85" />
      <path
        d="M156.5 344.5L168.1 354.8L179.7 344.5L191.3 354.8L202.9 344.5L214.5 354.8L226.1 344.5L237.7 354.8L249.4 344.5L261 354.8L272.6 344.5L284.2 354.8L295.8 344.5L307.4 354.8L319 344.5L330.7 354.8L342.3 344.5L342.1 302.9H156.5V344.5Z"
        fill="#FF2B85"
      />
      <path
        d="M247.3 199.3H186.1C183.6 199.3 181.5 197.2 181.5 194.7C181.5 192.2 183.6 190.1 186.1 190.1H247.3C249.8 190.1 251.9 192.2 251.9 194.7C251.9 197.3 249.9 199.3 247.3 199.3Z"
        fill="white"
      />
      <path
        d="M313.6 199.1H296C293.5 199.1 291.5 197.1 291.5 194.6C291.5 192.1 293.5 190.1 296 190.1H313.6C316.1 190.1 318.1 192.1 318.1 194.6C318 197.1 316 199.1 313.6 199.1Z"
        fill="white"
      />
      <path
        d="M247.3 222.9H186.1C183.6 222.9 181.5 220.8 181.5 218.3C181.5 215.8 183.6 213.7 186.1 213.7H247.3C249.8 213.7 251.9 215.8 251.9 218.3C251.9 220.8 249.9 222.9 247.3 222.9Z"
        fill="white"
      />
      <path
        d="M229.099 247.2H185.999C183.599 247.2 181.699 245.3 181.699 242.9C181.699 240.5 183.599 238.6 185.999 238.6H229.099C231.499 238.6 233.399 240.5 233.399 242.9C233.399 245.3 231.399 247.2 229.099 247.2Z"
        fill="white"
      />
      <path
        d="M229.099 300.5H185.999C183.599 300.5 181.699 298.6 181.699 296.2C181.699 293.8 183.599 291.9 185.999 291.9H229.099C231.499 291.9 233.399 293.8 233.399 296.2C233.399 298.6 231.399 300.5 229.099 300.5Z"
        fill="white"
      />
      <path
        d="M247.3 272.8H186.1C183.6 272.8 181.5 270.8 181.5 268.2C181.5 265.7 183.6 263.6 186.1 263.6H247.3C249.8 263.6 251.9 265.6 251.9 268.2C251.9 270.8 249.9 272.8 247.3 272.8Z"
        fill="white"
      />
      <path
        d="M313.6 222.6H296C293.5 222.6 291.5 220.6 291.5 218.1C291.5 215.6 293.5 213.6 296 213.6H313.6C316.1 213.6 318.1 215.6 318.1 218.1C318 220.6 316 222.6 313.6 222.6Z"
        fill="white"
      />
      <path
        d="M313.6 247.5H296C293.5 247.5 291.5 245.5 291.5 243C291.5 240.5 293.5 238.5 296 238.5H313.6C316.1 238.5 318.1 240.5 318.1 243C318 245.5 316 247.5 313.6 247.5Z"
        fill="white"
      />
      <path
        d="M313.6 272.6H296C293.5 272.6 291.5 270.6 291.5 268.1C291.5 265.6 293.5 263.6 296 263.6H313.6C316.1 263.6 318.1 265.6 318.1 268.1C318 270.6 316 272.6 313.6 272.6Z"
        fill="white"
      />
      <path
        d="M313.6 300.3H296C293.5 300.3 291.5 298.3 291.5 295.8C291.5 293.3 293.5 291.3 296 291.3H313.6C316.1 291.3 318.1 293.3 318.1 295.8C318 298.3 316 300.3 313.6 300.3Z"
        fill="white"
      />
      <path d="M342.2 144H156.6V164.5H342.2V144Z" fill="#D61E76" />
      <path
        d="M249.701 385.2C299.351 385.2 339.601 383.006 339.601 380.3C339.601 377.594 299.351 375.4 249.701 375.4C200.05 375.4 159.801 377.594 159.801 380.3C159.801 383.006 200.05 385.2 249.701 385.2Z"
        fill="#B7D2E2"
      />
    </svg>
  );
};

export default TransactionRefund;
